<div class="view-broadcasted-job-page" [ngClass]="cssClass">

  <div class = "mont-bold small-font bottom-10 applicant-card" *ngIf="hiredStaffers.length">Hired:</div>

  <ng-container *ngFor="let contractor of hiredStaffers | slice:contractorListStartIndex:contractorListEndIndex ; let i = index trackByIndex"> 
    <div class="applicant-card"> 
       <div class = "contractor-detail-card bottom-20"> 
       <app-shift-detail-container [cssClass]="cssClass"  [jobItem]="jobItem" [staffer] = "contractor" [userData] = "userData" [viewingHired]="true"></app-shift-detail-container> 
       <div class = "button-stack">
        
  
        <button class = "hire" *ngIf="previousShiftView" >
          <div class = "label">{{contractor.state}}</div>
        </button>
      </div>
      
      </div>
     </div> 

     <div>

    </div>
  </ng-container>
  <app-pagination [cssClass]="cssClass" *ngIf = "hiredStaffers && hiredStaffers.length" [totalRecords] = "hiredStaffers.length" (onPageChange) = "loadHiredStaffers($event)"></app-pagination>
  

  <div class = "mont-bold small-font bottom-10 applicant-card" *ngIf="pendingConfirmationStaffers.length">Pending Confirmation:</div>

  <ng-container *ngFor="let contractor of pendingConfirmationStaffers | slice:pendingContractorListStartIndex:pendingContractorListEndIndex; let i = index trackByIndex"> 
    <div class="applicant-card"> 
       <div class = "contractor-detail-card bottom-20"> 
       <app-shift-detail-container [cssClass]="cssClass" [jobItem]="jobItem" [staffer] = "contractor" [userData] = "userData"></app-shift-detail-container> 
      </div>
     </div> 

     <div>

    </div>
  </ng-container>
  <app-pagination [cssClass]="cssClass" *ngIf = "pendingConfirmationStaffers && pendingConfirmationStaffers.length" [totalRecords] = "pendingConfirmationStaffers.length" (onPageChange) = "loadPendingConfirmationStaffers($event)"></app-pagination>
 


  <div *ngIf = "interestedStaffers.length && !jobItem.isFilled" class = "mont-bold small-font bottom-10 applicant-card top-10">Contractors who applied:</div>
  
    <ng-container *ngFor="let applicant of interestedStaffers | slice:applicantListStartIndex:applicantListEndIndex ; let i = index trackByIndex">
    <div class="applicant-card" *ngIf = "!jobItem.isFilled"> 
      <div class = "contractor-detail-card bottom-20"> 
        <app-shift-detail-container [cssClass]="cssClass" [shiftSkill]="jobItem?.skill" [shiftAcceptableSkills]="jobItem?.acceptableSkills" [staffer] = "applicant" [userData] = "userData" (hireContractor) = "hire(applicant.staffer, applicant.status)"></app-shift-detail-container>
        <div class = "button-stack">
          <button (click)="reject(applicant.staffer, applicant.status)" class="reject mont-regular"
            *ngIf="applicant.status == 'interested' && !previousShiftView"> Reject
          </button>
    
          <button  (click)="hire(applicant.staffer, applicant.status)" class = "hire" [disabled]="isHiring" *ngIf="applicant.status == 'interested' && !previousShiftView" >
            <div class = "hire-txt">Hire</div>
            <div class = "ellipse"><i class = "fas fa-arrow-right"></i></div>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <app-pagination [cssClass]="cssClass" *ngIf = "interestedStaffers && interestedStaffers.length && !jobItem.isFilled" [totalRecords] = "interestedStaffers.length" (onPageChange) = "loadInterestedStaffers($event)"></app-pagination>
</div>
